/**
 * Copyright 2024 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */

export const OW_API_KEY = '99cca36e90e54d23bf7a885376d37302'; // Get at https://openweathermap.org/api
